import { SET_NON_REVIEWED_DATA } from "../../actions/action.types";

const nonReviewedData = (state = [], action: any) => {
  if (action.type === SET_NON_REVIEWED_DATA) return action.payload;
  else return state;
};

export default nonReviewedData;
